import styled from 'styled-components';
import { color, Common, Header } from '@stockbit/ui';

const { Flex } = Common;

const ButtonTrading = styled(Flex)`
  position: relative;
  align-items: center;
  border-left: 1px solid ${color.lowgray};
  justify-content: ${({ minimize = false }) =>
    minimize ? 'space-between' : 'space-around'};
  padding: ${({ minimize = false }) => (!minimize ? '16px 0' : '0 16px')};
  flex-direction: ${({ minimize = false }) => (!minimize ? 'column' : 'row')};
  width: ${({ minimize = false }) => (!minimize ? '110px' : '145px')};
  height: ${({ minimize = false }) => (!minimize ? '101px' : '60px')};
  cursor: pointer;

  ::after {
    content: '';
    position: absolute;
    width: 100%;
    top: 100%;
    right: 0;
    height: ${({ isActive = false }) => (isActive ? '1px' : 0)};
    background: ${color.light};
    z-index: 2;
  }
`;

const ButtonTradingGreen = styled(ButtonTrading)`
  background: ${({ isActive = false }) =>
    isActive ? color.light : 'linear-gradient(-29deg, #46aa9e, #3fb9aa)'};
  height: ${({ minimize = false }) => (!minimize ? '102px' : '61px')};
`;

export { ButtonTradingGreen };
